import { useEffect, useState } from "react";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Container,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import routes from "../../routes";
import nucleusxp from "nucleusxp";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (nucleusxp.isAuthenticated()) {
      navigate(routes.home.path);
    }
  }, [navigate]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLogin = async () => {
    if (username && password) {
      await nucleusxp.authenticate(username, password, {
        tenant: null,
      });

      if (nucleusxp.isAuthenticated()) {
        navigate(routes.home.path);
      }
    } else {
      alert("Please enter both username and password");
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5,
      }}
    >
      <Box
        component="img"
        src="images/nucleusx.png"
        alt="logo"
        sx={{ paddingTop: "86px" }}
      />
      <TextField
        label="Username"
        variant="outlined"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        fullWidth
      />
      <TextField
        label="Password"
        variant="outlined"
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        fullWidth
      />

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#2d3648",
          fontSize: "18px",
          color: "#fff",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 24px",
          width: "100%",
        }}
        onClick={handleLogin}
      >
        Login
      </Button>
    </Container>
  );
};

export default Login;
